function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  opacity: 0.1,
  width: 229.632,
  height: 1129.75,
  rx: 50,
  transform: "matrix(0.866044 0.499967 -0.866044 0.499967 953.171 -87.1165)",
  fill: "#F2F2F2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 128.822,
  y1: 281.437,
  x2: 115.043,
  y2: 1129.75,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F2F2F2",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})));

var SvgShadow = function SvgShadow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 894,
    height: 578,
    viewBox: "0 0 894 578",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShadow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Shadow.0d232d64.svg";
export { ForwardRef as ReactComponent };